import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "basemap-container" }

import { computed } from 'vue';
import { storeToRefs } from 'pinia';
// store
import { useWorkshop } from '@/store';
// assets
import { useBackgroundUrl } from '../useWorkshopImg';


export default /*#__PURE__*/_defineComponent({
  __name: 'main',
  setup(__props) {

_useCssVars(_ctx => ({
  "a4e534da": (_unref(mainBg).mobile)
}))

const { mainBg } = useBackgroundUrl();
const { updateScreenshotMode } = useWorkshop();
const { currentBasemap, currentPlaygroundStickers, screenshotMode } =
  storeToRefs(useWorkshop());
const pxToRem = 0.01;

const imageSizeOffset = {
  mobile: { x: 1, y: 1 },
  // background image size 1334 x 675 & 824 x 417
  tablet: { x: 13.34 / 6.75, y: 8.24 / 4.17 },
  // background image size 1334 x 675 & 824 x 417
  pc: { x: 13.34 / 6.75, y: 8.24 / 4.17 },
};
const RwdOffset = computed(() => {
  if (
    window.matchMedia('min-width: 750px').matches ||
    window.matchMedia('(orientation: landscape)').matches
  ) {
    return imageSizeOffset.tablet;
  } else if (window.matchMedia('min-width: 1280px').matches) {
    return imageSizeOffset.pc;
  } else return imageSizeOffset.mobile;
});

return (_ctx: any,_cache: any) => {
  return (_unref(screenshotMode))
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "screenshot",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(updateScreenshotMode)(false)))
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", {
            class: "basemap",
            style: _normalizeStyle({ 'background-image': `url(${_unref(currentBasemap)})` })
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(currentPlaygroundStickers), (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "sticker",
                key: index,
                style: _normalizeStyle({
            'background-image': `url(${item.selectedSticker.img})`,
            top: `${item.y}%`,
            left: `${item.x}%`,
            width: `${item.size * pxToRem * _unref(RwdOffset).x}rem`,
            height: `${item.size * pxToRem * _unref(RwdOffset).y}rem`,
          })
              }, null, 4))
            }), 128))
          ], 4)
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})